const DeepLinkAutomation = () => (
  <>
    {/* NOTE: Always place just before the closing </body> tag. */}
    <script src="https://www.anrdoezrs.net/am/100222554/include/allCj/impressions/page/am.js" />
  </>
)

export default DeepLinkAutomation
